import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  box-shadow: ${({ theme }) => theme.shadow[0]};
  position: relative;
  @media (max-width: 991px) {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100;
  }
`;
